import React, { useEffect, useState } from "react";
import { DatePicker, Form, InputNumber, Modal, Radio, Select } from "antd";
import CustomInput from "../../components/CustomInput";
import { useTranslation } from "react-i18next";
import CustomSelect from "../../components/CustomSelect";
import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import Notifications from "../../helpers/Notifications";
import "dayjs/locale/ru";
import { getPredictivePrice } from "../NRI/PredictivePrice/store/actions";
import CustomButton from "../../components/CustomButton";
import { recalculate, updatePtmResourcesPrice } from "./helpers";
import { getTariffRates } from "../NRI/TariffRate/store/actions";

const { Option } = Select;

const ConstructorForm = (props) => {
  const {
    visible,
    setVisible,
    formState,
    setFormState,
    project,
    setProject,
    isResource,
  } = props;
  const [zones, setZones] = useState([]);
  const regions = useSelector((state) => state.reRegionReducer.list);
  const zoneList = useSelector((state) => state.reZoneReducer.list);
  const buildTypes = useSelector((state) => state.reBuildTypeReducer.list);
  const referenceUnits = useSelector(
    (state) => state.referenceUnitReducer.list
  );
  const { list: predictiveList, isLoading: isPredictivePriceLoading } =
    useSelector((state) => state.predictivePriceReducer);
  const { list: tariffRateList, isLoading: isTariffRateLoading } = useSelector(
    (state) => state.tariffRateReducer
  );

  const { t } = useTranslation(["common", "valid", "kit", "nri", "action"]);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const year = new Date().getFullYear();

  useEffect(() => {
    if (predictiveList.length === 0) {
      dispatch(getPredictivePrice({ yearStart: year - 1 }));
    }
  }, []);

  useEffect(() => {
    //для выставление зон у региона для редактируемого проекта
    if (formState.regionId) {
      setRegionZones(formState.regionId);
    }
  }, [zoneList, formState.regionId]);

  function handleRegionChange(value) {
    setRegionZones(value);
    //form.resetFields(['zoneId'])
    form.setFieldValue("zoneId", undefined);
  }

  function setRegionZones(value) {
    if (zoneList.length > 0 && regions.length > 0) {
      let zones;
      let minsk = regions.find((n) => n.code === 5);
      if (value !== minsk.id) {
        zones = zoneList.filter((n) => n.code !== 3);
      } else {
        zones = zoneList.filter((n) => n.code === 3);
      }
      setZones(zones);
    }
  }

  function handleZoneChange(value) {
    setFormState((prevState) => ({ ...prevState, zoneId: value }));
  }

  function handleReferenceUnitChange(value) {
    setFormState((prevState) => ({ ...prevState, referenceUnitId: value }));
  }

  function onChangeValue(value) {
    setFormState((prevState) => ({ ...prevState, value: value }));
  }

  const onVatChange = (e) => {
    //setFormState(prevState => ({...prevState, vat: e.target.value}))
  };

  const onDateChange = (date) => {
    let dateYear = date.year();
    if (!predictiveList?.some((price) => price.year === dateYear)) {
      dispatch(getPredictivePrice({ yearStart: dateYear }));
    }
    if (isResource && !tariffRateList?.some((rate) => rate.year === dateYear)) {
      dispatch(getTariffRates(dateYear));
    }
  };

  const save = () => {
    form
      .validateFields()
      .then((values) => {
        const updateValues = {
          name: values.name.trim(),
          formationDate: values.formationDate,
          regionId: values.regionId,
          zoneId: values.zoneId,
          referenceUnitId: values.referenceUnitId,
          vat: values.vat,
          value: values.value,
          buildTypeId: values.buildTypeId,
        };

        const previousValues = {
          name: formState.name,
          formationDate: formState.formationDate,
          regionId: formState.regionId,
          zoneId: formState.zoneId,
          referenceUnitId: formState.referenceUnitId,
          vat: formState.vat,
          value: formState.value,
          buildTypeId: formState.buildTypeId,
        };

        if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
          Notifications.errorNotice(t("valid:sameData"), null, 10);
        else {
          let month = values.formationDate.month() + 1;
          let year = values.formationDate.year();
          let list = predictiveList?.find((n) => n.year === year)?.predictivePrices;
          if (!list || !list.length) {
            Notifications.errorNotice(`Отсутствуют прогнозные индексы за ${year} год.`);
            return;
          }
          let coefficient = 1; //прогнозный индекс, рассчитанный нарастающим итогом от текущей даты до базисного периода (1-й месяц года)
          list.forEach((price) => {
            if (price.month <= month) {
              coefficient = coefficient * price.value;
            }
          });
          let correction = 1; //поправочный коэффициент для ресурсного метода из справочника "Тарифная ставка
          if (isResource) {
            const tariffFirst = tariffRateList?.find((n) => n.month === 1)?.value;
            const tariffMonth = month == 1 ? tariffFirst : tariffRateList?.find((n) => n.month === month)?.value;
            if (tariffFirst === undefined) {
              Notifications.errorNotice(`Не найдена тарифная ставка 1-го месяца ${year} года.`)
              return
            }
            if (tariffMonth === undefined) {
              Notifications.errorNotice(`Не найдена тарифная ставка ${month}-го месяца ${year} года.`)
              return
            }
            correction = tariffMonth / tariffFirst;
          }
          setFormState((prevState) => ({
            ...prevState,
            ...updateValues,
            month: month,
            year: year,
            costIndex: coefficient,
            correction: correction,
          }));
          setVisible(false);

          if (isResource) {
            if (
              updateValues.formationDate !== formState.formationDate ||
              updateValues.regionId !== formState.regionId ||
              updateValues.zoneId !== formState.zoneId ||
              updateValues.vat !== formState.vat
            ) {
              if (project.objects.length > 0 && project.ptms.length > 0) {
                //formState запаздывает, поэтому формируем и передаём новый объект
                let newValues = {
                  ...updateValues,
                  month: month,
                  year: year,
                  costIndex: coefficient,
                  correction: correction,
                };
                let objectIds = project.objects.map((ob) => ob.id);
                updatePtmResourcesPrice(
                  objectIds,
                  project.ptms,
                  newValues,
                  setUpdated
                );
              }
            }
          }
        }
      })
      .catch((_) => {
        Notifications.errorNotice(t("valid:formNeed"), null, 10);
      });
  };

  function setUpdated(ptms) {
    recalculate(ptms, project.objects);
    setProject((prevState) => ({ ...prevState, ptms: ptms }));
  }

  return (
    <Modal
      destroyOnHidden
      footer={[
        <CustomButton
          key="save"
          //loading={isSending}
          type="green"
          onClick={save}
          loading={isPredictivePriceLoading || isTariffRateLoading}
        >
          {t("action:fixSelection")}
        </CustomButton>,
      ]}
      title={`Заполните данные для пользовательского объекта-аналога`}
      open={visible}
      width={900}
      onCancel={() => setVisible(false)}
    >
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 12 }}
        layout="horizontal"
        //disabled={componentDisabled}
        //style={{ maxWidth: 600 }}
        initialValues={{
          name: formState.name,
          formationDate: formState.formationDate,
          regionId: formState.regionId,
          zoneId: formState.zoneId,
          referenceUnitId: formState.referenceUnitId,
          vat: formState.vat,
          value: formState.value,
          buildTypeId: formState.buildTypeId,
        }}
      >
        <Form.Item
          label={t("common:name")}
          name="name"
          rules={[
            {
              required: true,
              whitespace: true,
              min: 3,
              max: 200,
            },
          ]}
        >
          <CustomInput
            maxLength={250}
            placeholder={`${t("action:enter")} ${t(
              "common:name"
            ).toLowerCase()}`}
          />
        </Form.Item>
        <Form.Item
          label={t("kit:formationDate")}
          name="formationDate"
          rules={[
            {
              required: true,
              message: "Необходимо выбрать месяц.",
            },
          ]}
        >
          <DatePicker
            format={"MM.YYYY"}
            picker="month"
            disabledDate={d => !d || d.isAfter(new Date(year, 11, 31))
              //|| d.isBefore(new Date(year, 0, 1))
            }
            className="custom-input"
            onChange={onDateChange}
          />
        </Form.Item>
        <Form.Item
          label={t("common:region")}
          name="regionId"
          rules={[{ required: true }]}
        >
          <CustomSelect
            allowClear
            showSearch
            filterOption={false}
            notFoundContent={null}
            placeholder={`${t("action:choose")} ${t(
              "common:region"
            ).toLowerCase()}`}
            onChange={handleRegionChange}
          >
            {regions.map((item) => {
              return (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              );
            })}
          </CustomSelect>
        </Form.Item>
        <Form.Item
          label={t("common:zone")}
          name="zoneId"
          rules={[{ required: true }]}
        >
          <CustomSelect
            //setPropsSate={setZoneId}
            allowClear
            showSearch
            filterOption={false}
            notFoundContent={null}
            placeholder={`${t("action:choose")} ${t("common:zone").toLowerCase()}`}
          //onChange={handleZoneChange}
          //onSearch={handleChange}
          >
            {zones?.map((item) => {
              return (
                <Option key={item.id} value={item.id}>
                  {`${item.code} ${t("common:zone")}`}
                </Option>
              );
            })}
          </CustomSelect>
        </Form.Item>
        <Form.Item
          label={t("nri:referenceUnit")}
          name="referenceUnitId"
          rules={[{ required: true }]}
        >
          <CustomSelect
            //setPropsSate={setReferenceUnitId}
            allowClear
            showSearch
            filterOption={false}
            notFoundContent={null}
            placeholder={`${t("action:choose")} эталонную единицу`}
          //onChange={handleReferenceUnitChange}
          //onSearch={(e) => setSearchRegion(e)}
          >
            {referenceUnits?.map((item) => {
              return (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              );
            })}
          </CustomSelect>
        </Form.Item>
        <Form.Item
          label={t("common:volume")}
          name="value"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber
            min={0}
            max={2147483647}
            //placeholder={`${t('action:enter')} объем, на который в дальнейшем будут проводиться расчеты`}
            //onChange={(e) => onChangeValue(e)}
            className="custom-input"
          />
        </Form.Item>
        <Form.Item label="НДС" name="vat">
          <Radio.Group onChange={onVatChange}>
            <Radio value={false}>без налога</Radio>
            <Radio value={true}>с налогом</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label={t("nri:buildType")}
          name="buildTypeId"
          rules={[
            {
              required: true,
              pattern: /1/,
              message:
                'на данный момент реализован только вид "новое строительство"',
            },
          ]}
        >
          <CustomSelect
            allowClear
            showSearch
            filterOption={false}
            notFoundContent={null}
            placeholder={`${t("action:choose")} вид строительства`}
          //onSearch={(e) => setSearchRegion(e)}
          >
            {buildTypes?.map((item) => {
              return (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              );
            })}
          </CustomSelect>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ConstructorForm;
/*
<Form.Item
    label={t('common:zoneBuild')}
    name="zone"
>
    <Cascader
        className='custom-select'
        options={[
            {
                value: 1,
                label: 'Зона 1',
                children: cities.map((el, idx) => ({value: el.id, label: el.name}))
            },
            {
                value: 2,
                label: 'Зона 2',
                children: regions.filter(n => n.code !== 5).map((el) => ({
                    value: el.id,
                    label: el.name
                }))
            },
            {
                value: 3,
                label: 'Зона 3',
                children: regions.filter(n => n.code === 5).map((el) => ({
                    value: el.id,
                    label: el.name
                }))
            },
        ]}
        onChange={onChange}
    />
</Form.Item>*/
